import { useState, useEffect, useCallback } from 'react';
import { setCookie, getCookie, deleteCookie } from 'cookies-next';
import jwt_decode from "jwt-decode";

function useSession() {


    const updateToken = (token: string) => {

        if (token) {

            let res = setCookie("token", token, {
                maxAge: 30 * 24 * 60 * 60,
                path: "/",
                // domain: DOMAIN
            });

            let session = parseToken(token);

            setToken(token);

            //setSession(session);
        }

    };


    const parseToken = (token: string): any => {

        let decoded = jwt_decode(token);

        console.log("DECODED", decoded);

        return decoded;
    }

    const getSession = useCallback(() => {

        try {
            let token = getCookie("token");

            console.log("TOKEN", token)
            if (token != undefined) {


                let session = parseToken(token as string);

                console.log("SESSION", session)
                return token;

            }

            return undefined;

        
        } catch (_b) {
            // This catch block handles the known issues listed here: https://caniuse.com/#feat=namevalue-storage
            console.warn(
                "useSession could not access the browser storage. Session will be lost when closing browser window"
            );
        }
        return null;
    }, []);

    const [token, setToken] = useState(getSession);


    const clear = () =>{
        deleteCookie("token");
        setToken(undefined)
    }

    const hasSession = (): boolean => {

        return token != undefined;
    }

    const getTBUid = (): string | undefined => {

        if (token) {
            let session = parseToken(token as string);
            return session.tbUid;
        }

    }

    /*  useEffect(() => {
  
          if (token) {
  
              let res = setCookie("token", token, {
                  maxAge: 30 * 24 * 60 * 60,
                  path: "/",
                  // domain: DOMAIN
              });
  
              setSession(getSession);
          }
  
      }, [token]);*/


    return { updateToken, hasSession, getTBUid, token,clear  };
}

export default useSession;